export const SIGNINTYPE = {
  email: 'Email',
  emailOTP: 'Email-otp',
  phone: 'Phone',
  reauthEmail: 'Reauth-Email',
  reauthPhone: 'Reauth-Phone',
};

export const countDown = (seconds, callback, done) => {
  const COUNTDOWN_BASE = seconds - 1;
  let COUNTDOWN = seconds - 1;

  const interval = window.setInterval(() => {
    callback(COUNTDOWN--);

    if (COUNTDOWN <= -1) {
      COUNTDOWN = COUNTDOWN_BASE;
      window.clearInterval(interval);
      done();
    }
  }, 1000);

  return interval;
};

export const GenerateGUID = () => {
  return 'xxxxxxxx-xxxx4xxxyxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const hashData = async (message, algo) => {
  const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
  const hashBuffer = await crypto.subtle.digest(algo, msgUint8); // hash the message
  const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
  return hashHex;
};
